import { Dispatch } from "redux";
import api from "../../api/api";
import {
    setloading,
    seterror,
    setGrading,
    resetGrading
} from "../reducers/editGradingReducer";

const getEditGrading = (data: any, token: any) => async (
    dispatch: Dispatch
) => {
    dispatch(setloading(true));
    try {
        const result = await api.post(`submissions/edit-update-grade/`, data, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Token ${token}`,
            },
        });



        if (result) {
            dispatch(setloading(false));
            dispatch(setGrading(result.data.message)); 
        }
    } catch (error: any) {
        dispatch(setloading(false));
        dispatch(seterror(error.response?.data?.message ?? "Something Went Wrong!"));
    }
};

export { getEditGrading, resetGrading };

